import { addUserAvatar } from "../../api/user/profile";
import { StyledProfileDetailsImage } from "../../styles/StyledProfileDetails";
import { useEffect, useState } from "react";
import AddIcon from "../../assets/img/icons/add-black.svg";
import Dropzone from "../Dropzone/Dropzone";
import Modal from "react-modal";
import ModalHeader from "../ModalHeader/ModalHeader";
import PropTypes from "prop-types";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const customStyles = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		minWidth: "440px",
		maxWidth: "60vw",
		padding: "25px",
		maxHeight: "80vh",
		overflowY: "auto",
		background: "#F7F8F9",
	},
};

export default function ProfileDetailsImage({ avatar, edit }) {
	const { axiosPrivate } = useAxiosPrivate();
	const [modalIsOpen, setIsOpen] = useState(false);

	useEffect(() => {
		Modal.setAppElement("body");
	});

	const openModal = () => {
		setIsOpen(true);
	};

	const closeModal = () => {
		setIsOpen(false);
	};

	const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/x-icon"];

	const handleAvatarUpload = (file) => {
		let formData = new FormData();

		formData.append("avatar", file[0]);

		addUserAvatar(
			axiosPrivate,
			() => {
				closeModal();
			},
			formData
		);
	};

	return (
		<>
			<StyledProfileDetailsImage>
				{avatar !== undefined && <img src={avatar} alt="profile-image" />}
				{edit && (
					<button onClick={openModal}>
						<img src={AddIcon} alt="add-profile-image" />
					</button>
				)}
			</StyledProfileDetailsImage>
			<Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={customStyles} appElement={document.getElementById("app")}>
				<ModalHeader onClick={() => closeModal()}>Upload your avatar (max 500px width)</ModalHeader>
				<Dropzone cb={handleAvatarUpload} validTypes={validTypes} single />
			</Modal>
		</>
	);
}

ProfileDetailsImage.propTypes = {
	avatar: PropTypes.string,
	edit: PropTypes.bool,
};

ProfileDetailsImage.defaultProps = {
	edit: false,
};
